<template>
  <div>
    <validation-observer ref="refFormObserver">
      <b-form>
        <b-row>
          <b-col cols="12" lg="6">
            <form-field-text
              id="dmp_name"
              v-model="itemData.name"
              :label="$t('dmp.name')"
              rules="required"
              class="mt-1"
            />
          </b-col>

          <!-- Panel Host / IP toggle -->
          <b-col cols="12" lg="6">
            <host-ip-input
              v-model="itemData.panel_host"
              :label="$t('dmp.panelHost')"
              :show-port="true"
            />
          </b-col>

          <b-col cols="12" lg="6">
            <form-field-text
              id="dmp_panel_account"
              v-model="itemData.panel_account"
              :label="$t('dmp.panelAccount')"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="dmp_panel_remote_key"
              v-model="itemData.panel_remote_key"
              :label="$t('dmp.panelRemoteKey')"
              type="password"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="dmp_description"
              v-model="itemData.instance_host"
              :label="$t('dmp.instance_host')"
              rules="required"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-select
              id="dmp_panel_listening_port"
              v-model="itemData.id_dmp_profile"
              :label="$t('dmp.profile')"
              :options="profileOptions"
              :reduce-option="(val) => val.id"
              option-label="name"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <validation-provider #default="validationContext" :name="'Facility'">
              <b-form-group
                :label="'Facility'"
                :label-for="'dmp_id_facility'"
                :state="getValidationState(validationContext)"
                rules="required"
              >
                <v-select
                  id="dmp_id_facility"
                  :options="facilitiesOptions"
                  :value="itemData.id_unit"
                  @input="changedUnit"
                  multiple
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  class="w-100"
                  append-to-body
                  :calculate-position="withPopper"
                  :reduce="(val) => val.value"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
          
          <b-col cols="12" lg="6">
            <!-- Additional router -->
            <validation-provider #default="validationContext" :name="$t('hanwha_dvr.router')" rules="required">
              <b-form-group
                class="text-capitalize"
                :label="$t('hanwha_dvr.router')"
                label-for="id_additional_router"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  :clereable="false"
                  :reduce="(val) => val.id"
                  :options="additionalRouters"
                  input-id="id_additional_router"
                  :get-option-label="(option) => `IP ${option.ip_vpn ? option.ip_vpn : 'N/A'}`"
                  v-model="itemData.id_additional_router"
                  :disabled="!itemData.id_unit"
                >
                  <template #option="{ ip_vpn }">
                    <span>IP {{ ip_vpn ? ip_vpn : "N/A" }}</span>
                  </template>
                </v-select>
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12" lg="6">
            <form-field-select
              id="dmp_id_center"
              v-model="itemData.id_center"
              label="Center"
              :options="centerOptions"
              rules="required"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-select
              id="dmp_id_sector"
              v-model="itemData.id_sector"
              label="Sector"
              :options="sectorOptions"
              rules="required"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-select
              id="id_reseller"
              v-model="itemData.id_omniview_reseller"
              label="Reseller"
              :options="resellerOptions"
              rules="required"
            />
          </b-col>

          <!-- empty col -->
          <b-col cols="12" lg="6"></b-col>

          <!-- enabled_zones_audit -->
          <b-col cols="12" lg="6">
            <b-form-group class="mt-1">
              <b-form-checkbox
                v-model="itemData.enabled_zones_audit"
                switch
              >
                {{ $t('dmp.enabled_zones_audit') }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- days_zones_audit -->
          <b-col v-if="itemData.enabled_zones_audit" cols="12" lg="6">
            <validation-provider
              #default="validationContext"
              rules="required|positive"
              :name="$t('dmp.days_zones_audit')"
            >
              <b-form-group
                :label="$t('dmp.days_zones_audit')"
                label-for="days_zones_audit"
              >
                <b-form-input
                  id="days_zones_audit"
                  v-model.number="itemData.days_zones_audit"
                  type="number"
                  :state="getValidationState(validationContext)"
                  min="1"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

          <!-- enabled_areas_audit -->
          <b-col cols="12" lg="6">
            <b-form-group class="mt-1">
              <b-form-checkbox
                v-model="itemData.enabled_areas_audit"
                switch
              >
                {{ $t('dmp.enabled_areas_audit') }}
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- days_areas_audit -->
          <b-col v-if="itemData.enabled_areas_audit" cols="12" lg="6">
            <validation-provider
              #default="validationContext"
              rules="required|positive"
              :name="$t('dmp.days_areas_audit')"
            >
              <b-form-group
                :label="$t('dmp.days_areas_audit')"
                label-for="days_areas_audit"
              >
                <b-form-input
                  id="days_areas_audit"
                  v-model.number="itemData.days_areas_audit"
                  type="number"
                  :state="getValidationState(validationContext)"
                  min="1"
                />
                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import {ref} from "@vue/composition-api";
import { BFormCheckbox, BFormGroup, BFormInput, BFormInvalidFeedback } from "bootstrap-vue";
import FormFieldText from "@/components/WizardModal/FormFields/FormFieldText.vue";
import FormFieldToggle from "@/components/WizardModal/FormFields/FormFieldToggle.vue";
import FormFieldSelect from "@/components/WizardModal/FormFields/FormFieldSelect.vue";
import HostIpInput from "@/components/HostIpInput.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import formValidation from "@core/comp-functions/forms/form-validation";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";

export default {
  name: "DmpPanelsGeneralWizard",
  components: {
    FormFieldText,
    FormFieldToggle,
    FormFieldSelect,
    HostIpInput,
    ValidationObserver,
    ValidationProvider,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    vSelect,
  },
  props: {
    itemData: {
      type: Object,
      required: true,
    },
    profileOptions: {
      type: Array,
      default: () => [],
    },
    facilitiesOptions: {
      type: Array,
      required: true,
    },
    centerOptions: {
      type: Array,
      required: true,
    },
    sectorOptions: {
      type: Array,
      required: true,
    },
    resellerOptions: {
      type: Array,
      required: true,
    },
    virtualBypass: {
      type: Boolean,
      required: false,
    },
    additionalRouters: {
      type: Array,
      required: false,
      default: () => []
    },
  },
  setup(props, { emit }) {
    const { t } = useI18nUtils();
    const { refFormObserver, getValidationState } = formValidation();

    

    const changedUnit = (unit) => {
      emit('update:itemData', {
        ...props.itemData,
        id_unit: unit
      })

      emit('update:unit', unit)
    }

    return {
      t,
      refFormObserver,
      getValidationState,
      changedUnit,
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
<style>

</style>
